// Dynamic generation of static completion terms for search functionality
// Terms are generated based on sales channel mappings

const SCHEMA_BY_SCID = {
    'www-autoteile24-de': 'autoteile24',
    'www-k24-at': 'k24at',
    'www-kfzteile-com': 'kfzteile',
    'sis_tirendo-delticom-de': 'tirendo',
    'otc_branch1-kfzteile24-de': 'otc',
    'otc_branch2-kfzteile24-de': 'otc',
    'otc_branch3-kfzteile24-de': 'otc',
};

const URL_PREFIXES = {
    autoteile24: '/ersatzteile-verschleissteile/',
    kfzteile: '/autoteile/',
    k24at: '/kategorie/ersatzteile-verschleissteile/',
    tirendo: '/kategorie/autoteile/',
    otc: '/kategorie/autoteile/',
};

const BASE_TERMS = [
    { label: 'Bremsbeläge', value: 'Bremsbeläge', searchType: 'static', genart: 402 },
    { label: 'Bremssattel', value: 'Bremssattel', searchType: 'static', genart: 82 },
    { label: 'Bremsscheiben', value: 'Bremsscheiben', searchType: 'static', genart: 78 },
    { label: 'Lenker / Querlenker', value: 'Lenker / Querlenker', searchType: 'static', genart: 273 },
    { label: 'Luftfilter', value: 'Luftfilter', searchType: 'static', genart: 8 },
    { label: 'Ölfilter', value: 'Ölfilter', searchType: 'static', genart: 7 },
    { label: 'Radlagersatz', value: 'Radlagersatz', searchType: 'static', genart: 654 },
];

const URL_SUFFIXES = {
    'Bremsbeläge': 'bremsanlage/bremsbelaege',
    'Bremssattel': 'bremsanlage/bremssattel/bremssattel-halter-traeger',
    'Bremsscheiben': 'bremsanlage/bremsscheiben',
    'Lenker / Querlenker': 'achsaufhaengung/lenker-querlenker/lenker-quer-laengs-schraeg',
    'Luftfilter': 'filter/luftfilter',
    'Ölfilter': 'filter/oelfilter',
    'Radlagersatz': 'achsaufhaengung/radnabe-radlager/radlager',
};

export function getStaticCompletions(salesChannelId) {
    const schemaName = SCHEMA_BY_SCID[salesChannelId];
    const prefix = URL_PREFIXES[schemaName] || '';
    return BASE_TERMS.map(term => ({
        ...term,
        url: prefix + (URL_SUFFIXES[term.value] || ''),
    }));
}
